import { CopyOutlined } from '@ant-design/icons';
import { App } from 'antd';
import { memo, useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

interface CredentialsConsumerProps {
  apiKey: string;
}

export const ConsumerApiKey = memo(({ apiKey }: CredentialsConsumerProps) => {
  const [isSuccess, setSuccess] = useState(false);
  const { message } = App.useApp();

  useEffect(
    () => void (isSuccess && message.success('Api key was successfully copied', () => setSuccess(false)), [isSuccess]),
  );

  return (
    <CopyToClipboard text={apiKey} onCopy={() => setSuccess(true)}>
      <span style={{ cursor: 'pointer' }}>
        {apiKey} <CopyOutlined />
      </span>
    </CopyToClipboard>
  );
});
